import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightSmall = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={7} height={12} viewBox="0 0 7 12" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><path d="M7 0H0v12h7z" /><path stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M1.243 1.757 5.485 6l-4.242 4.243" /></g></svg>;
const ForwardRef = forwardRef(SvgArrowRightSmall);
export { ForwardRef as ReactComponent };